<template>
  <div class="ContentCss">
    <el-card>
      <el-form ref="form" label-width="80px" size="mini" :inline="true">
        <el-form-item label="词槽名称">
          <el-input v-model="keys"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="HandelFun('search')"
            >搜索</el-button
          >
          <el-button type="primary" @click="HandelFun('add')">新增</el-button>
           <el-upload
            style="display:inline-block;margin-left:10px"
            ref="upload"
            accept=".xls,.xlsx"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="upload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <!-- 导入的excel表格和展示的表头名el-table的prop对应 -->
            <el-button type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        style="width: 100%"
        size="mini"
        align="center"
      >
        <el-table-column prop="keyword" label="词槽名称"> </el-table-column>
        <el-table-column prop="words" label="内容"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="HandelFun('edit', scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="HandelDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="allCount"
        @current-change="CurrentChange"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogTableVisible"
      size="mini"
      center
    >
      <el-form label-width="120px" size="mini">
        <el-form-item label="词槽名称">
          <el-input v-model.trim="EditObj.keyword"></el-input>
        </el-form-item>
        <el-form-item label="词槽内容">
          <el-input type="textarea" v-model.trim="EditObj.words"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button type="primary" @click="HandelFun('save')" size="mini"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import XLSX from "../../utils/xlsx.core.min.js";
export default {
  data() {
    return {
      keys: "",
      content: "",
      tableData: [],
      dialogTableVisible: false,
      EditObj: {
        tid: "",
        keyword: "", //关键词
        words: "" // 内容
      },
      allCount: 1,
      pageindex: 1,
      isAdd: false
    };
  },
  methods: {
    // 页码函数
    CurrentChange(e) {
      this.pageindex = e;
      this.getWordsFun();
    },
     upload(file, filess) {
      let files = { 0: file.raw };
      this.readExcel(files);
    },
    // 读取 excel文件
    readExcel(files) {
      // 表格导入
      var that = this;
      console.log(files);
      if (files.length <= 0) {
        // 如果没有文件名
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }

      const fileReader = new FileReader();
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result;
          // console.log("data", data);
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          console.log(wsname);
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          const data1 = [];

          ws.forEach(item => {
            console.log(item);
            const data2 = {};
            Object.keys(item).forEach(item1 => {
              if (item1 == "词槽名称") {
                data2["keyword"] = item[item1];
              } else if (item1 == "内容") {
                data2["words"] = item[item1];
              } 
            });
            data1.push(data2);
          });
          console.log(data1, "data1是表格里的数据，且是json格式");
          // this.addSentenceListFun(data1);
          // 重写数据
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        action:'addmulti',
        addmulti:data1
      }
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/addWords", {
          data: JSON.stringify(this.$Help(params))
        })
        .then(res => {
          loading.close();
          if (res.data.add_count) {
            this.getWordsFun();
            this.$message({
              showClose: true,
              message: "成功",
              duration: 2000,
              type: "success",
              onClose: res => {}
            });
          }
        });
          this.$refs.upload.value = "";
        } catch (e) {
          console.log(e);
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    // 操作按钮
    HandelFun(type, data) {
      if (type == "search") {
        this.pageindex = 1;
        this.getWordsFun();
        return;
      }
      if (type == "edit") {
        this.isAdd = false;
        this.EditObj = data;
        this.dialogTableVisible = true;
        return;
      }
      if (type == "add") {
        this.isAdd = true;
        this.EditObj = {
          tid: "", //
          keyword: "", //关键词
          words: "" // 内容
        };
        this.dialogTableVisible = true;
        return;
      }
      if (type == "save") {
        if (this.EditObj.keyword && this.EditObj.words) {
          // let idx = this.tableData.findIndex(item => {
          //   return item.keyword == this.EditObj.keyword;
          // });
          // if (idx == -1) {
          this.addWordsFun();
          // } else {
          //   this.$message({
          //     showClose: true,
          //     message: "已有词槽名称，请勿重复添加",
          //     type: "error"
          //   });
          // }
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整后提交",
            type: "error"
          });
        }
      }
    },
    HandelDelete(_data) {
      this.$confirm("正在进行删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            action: "delete",
            tid: _data.tid
          };
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          this.$axios
            .Postdata("manage/Voicerecordreport.asmx/addWords", {
              data: JSON.stringify(this.$Help(params))
            })
            .then(res => {
              loading.close();
              console.log(res);
              if (res.data.errcode == 0) {
                this.getWordsFun();
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  duration: 2000,
                  type: "success",
                  onClose: res => {}
                });
              } else {
                this.$message({
                  message: res.data.errmsg,
                  duration: 2000,
                  type: "error"
                });
              }
            });
        })
        .catch(() => {});
    },
    // 获取词槽
    getWordsFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = {
        keyword: this.keys,
        pageindex: this.pageindex,
        pagesize: "10"
      };
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getWords", {
          data: JSON.stringify(this.$Help(data))
        })
        .then(res => {
          loading.close();
          this.tableData = res.data.detail;
          this.allCount = res.data.totalcount;
        });
    },
    // 添加词槽
    addWordsFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/addWords", {
          data: JSON.stringify(this.$Help(this.EditObj))
        })
        .then(res => {
          loading.close();
          if (res.data.tid) {
            this.isAdd = false;
            this.dialogTableVisible = false;
            this.getWordsFun();
            this.$message({
              showClose: true,
              message: "成功",
              duration: 2000,
              type: "success",
              onClose: res => {}
            });
          }
        });
    }
  },
  created() {
    this.getWordsFun();
  }
};
</script>
<style scoped>
.ContentCss {
  padding: 8px;
  box-sizing: border-box;
}
</style>
